import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
import { calculateAge } from '../../../../../utils/common';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 0,
    marginBottom: 0,
    borderTop: '0.5px solid black',
    borderRight: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '0.5px solid black',
    padding: 10
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 0,
    padding: 5,
    borderTop: '0.5px solid black',
    borderRight: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '0.5px solid black'
  },
  column: {
    flex: 1,
    paddingHorizontal: 10,

  },
  row: {
    flexDirection: 'row',
    marginBottom: 2
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5,
    minHeight: '100px'
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '12.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  tableCell: {
    fontSize: 10
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: 5,
    border: '1px solid black',
    marginTop: 10,
    backgroundColor: '',
    color: 'white'
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: 5,
    border: '1px solid black',
    marginTop: 10,
    backgroundColor: '',
    color: 'black'
  },
  headerText: {
    fontSize: 8,
    fontWeight: 'bold',
    marginLeft: 25,
    marginRight: 25
  },
  columnHeader: {
    width: 'auto'
  },
  columnText: {
    width: '10%',
    textAlign: 'center'
  },
  columnTextWide: {
    width: '17%',
    textAlign: 'center'
  },
  columnTextNarrow: {
    width: '5%',
    textAlign: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const IVFProgressReportPdf = ({ data }) => {
  console.log(data);
  const medicines = data?.medicines || [];
  const user = JSON.parse(localStorage.getItem('user'));
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`IVF Examination`}>
          <Page size="A4" style={styles.page} orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text content="IVF Examination Progress Report" style={{ fontSize: '12px', margin: '0 auto',fontFamily:"Roboto" }} />
            </View>
            <View style={styles.contentContainer}>
              <View style={{...styles.column,display:"flex",justifyContent:"space-evenly"}}>
                <View style={styles.row}>
                  <Text content="Patient Name       :     " style={{...styles.textBold,fontFamily:"Roboto"}} />
                  <Text content={`${data.patient?.name_suffix} ${data.patient?.first_name} ${data.patient?.last_name}`} />
                </View>
                <View style={styles.row}>
                  <Text content="UHID No.               :     " style={{...styles.textBold,fontFamily:"Roboto"}}/>
                  <Text content={`${data?.patient?.uhid || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Address                 :    " style={{...styles.textBold,fontFamily:"Roboto"}} />
                  <Text content={`${data?.patient?.address?.address || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Consultant            :     " style={{...styles.textBold,fontFamily:"Roboto"}}/>
                  <Text content={`${data.patient?.consultant?.name || ''}`} />
                </View>
              </View>
              <View style={styles.column}></View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Age/Sex              :      " style={{...styles.textBold,fontFamily:"Roboto"}}/>
                  <Text content={`${calculateAge(data.patient?.dob) || ''} / ${data.patient?.gender || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Department        :     " style={{...styles.textBold,fontFamily:"Roboto"}} />
                  <Text content={`${data?.patient?.department?.department || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Guardian              :     " style={{...styles.textBold,fontFamily:"Roboto"}} />
                  <Text content={`${data?.patient?.guardian_name || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Mob No.              :     " style={{...styles.textBold,fontFamily:"Roboto"}} />
                  <Text content={`${data?.patient?.address?.mobile || ''}`} />
                </View>
              </View>
            </View>

            {/* Table */}
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '20%',fontFamily:"Roboto" }} />
              <Text content="Allergy Type" style={{ ...styles.columnText, width: '40%',fontFamily:"Roboto" }} />
              <Text content="Description" style={{ ...styles.columnText, width: '40%',fontFamily:"Roboto" }} />
              <Text content="Date" style={{ ...styles.columnText, width: '40%',fontFamily:"Roboto" }} />
            </View>

            {data?.allergy_items?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '20%' }}  />
                <Text content={item.allergy_type || '-'} style={{ ...styles.columnText, width: '40%',textAlign:"start" }} />
                <Text content={item.description || '-'} style={{ ...styles.columnText, width: '40%',textAlign:"start" }} />
                <Text content={formatDate(item.createdAt) || '-'} style={{ ...styles.columnText, width: '40%' }} />
              </View>
            ))}

            {/* Table for Clinical Exam */}
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '20%',fontFamily:"Roboto" }}  />
              <Text content="Exam Type" style={{ ...styles.columnText, width: '40%',fontFamily:"Roboto" }} />
              <Text content="Description" style={{ ...styles.columnText, width: '40%',fontFamily:"Roboto" }}  />
              <Text content="Date" style={{ ...styles.columnText, width: '40%',fontFamily:"Roboto" }}  />
            </View>

            {data?.clinicalexam_items?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '20%' }} />
                <Text content={item.exam_type || '-'} style={{ ...styles.columnText, width: '40%',textAlign:"start" }} />
                <Text content={item.description || '-'} style={{ ...styles.columnText, width: '40%',textAlign:"start" }} />
                <Text content={formatDate(item.createdAt) || '-'} style={{ ...styles.columnText, width: '40%' }} />
              </View>
            ))}

            {/* Table for Complaint Items */}
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText ,width:"20%",fontFamily:"Roboto"}} />
              <Text content="Complaint Type" style={{ ...styles.columnText ,width:"40%",fontFamily:"Roboto"}} />
              <Text content="Duration" style={{ ...styles.columnText ,width:"40%",fontFamily:"Roboto"}} />
              <Text content="Date" style={{ ...styles.columnText ,width:"40%",fontFamily:"Roboto"}} />
            </View>

            {data?.complaint_items?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '20%' }} />
                <Text content={item.complaint_type || '-'} style={{ ...styles.columnText, width: '40%',textAlign:"start" }} />
                <Text content={item.duration || '-'} style={{ ...styles.columnText, width: '40%',textAlign:"start" }} />
                <Text content={formatDate(item.createdAt) || '-'} style={{ ...styles.columnText, width: '40%' }} />
              </View>
            ))}

            {/* Table for Disease Items */}
            <View style={styles.headerContainer}>
              <Text content="S. No."  style={{ ...styles.columnText, width: '20%',fontFamily:"Roboto" }}/>
              <Text content="Disease Type" style={{ ...styles.columnText, width: '40%',fontFamily:"Roboto" }} />
              <Text content="Description"  style={{ ...styles.columnText, width: '40%',fontFamily:"Roboto" }} />
              <Text content="Date"  style={{ ...styles.columnText, width: '40%',fontFamily:"Roboto" }} />
            </View>

            {data?.disease_items?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '20%' }} />
                <Text content={item.disease_type || '-'} style={{ ...styles.columnText, width: '40%',textAlign:"start" }} />
                <Text content={item.description || '-'} style={{ ...styles.columnText, width: '40%',textAlign:"start" }}/>
                <Text content={formatDate(item.createdAt) || '-'} style={{ ...styles.columnText, width: '40%' }}/>
              </View>
            ))}

            {/* Table for Family History */}
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '20%' ,fontFamily:"Roboto"}}/>
              <Text content="Disease" style={{ ...styles.columnText, width: '30%',fontFamily:"Roboto" }} />
              <Text content="Relation" style={{ ...styles.columnText, width: '30%',fontFamily:"Roboto"}} />
              <Text content="Description" style={{ ...styles.columnText, width: '30%',fontFamily:"Roboto" }} />
              <Text content="Date" style={{ ...styles.columnText, width: '30%',fontFamily:"Roboto" }} />
            </View>

            {data?.family_history?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '20%' }} />
                <Text content={item.disease || '-'} style={{ ...styles.columnText, width: '30%' ,textAlign:"start"}} />
                <Text content={item.relation || '-'} style={{ ...styles.columnText, width: '30%',textAlign:"start" }} />
                <Text content={item.description || '-'} style={{ ...styles.columnText, width: '30%', textAlign:"start"}} />
                <Text content={formatDate(item.createdAt) || '-'} style={{ ...styles.columnText, width: '30%' }} />
              </View>
            ))}

            {/* Table for General Exam Items */}
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '20%',fontFamily:"Roboto" }} />
              <Text content="Exam Type" style={{ ...styles.columnText, width: '40%' ,fontFamily:"Roboto"}} />
              <Text content="Description" style={{ ...styles.columnText, width: '40%' ,fontFamily:"Roboto"}} />
              <Text content="Date" style={{ ...styles.columnText, width: '40%' ,fontFamily:"Roboto"}} />
            </View>

            {data?.generalexam_items?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '20%' }} />
                <Text content={item.exam_type || '-'} style={{ ...styles.columnText, width: '40%' ,textAlign:"start"}} />
                <Text content={item.description || '-'} style={{ ...styles.columnText, width: '40%',textAlign:"start" }} />
                <Text content={formatDate(item.createdAt) || '-'} style={{ ...styles.columnText, width: '40%' }} />
              </View>
            ))}

            {/* Table for Investigation Items */}
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }} />
              <Text content="Service Name" style={{ ...styles.columnText, width: '30%',fontFamily:"Roboto" }} />
              <Text content="Type" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }} />
              <Text content="Quantity" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }} />
              <Text content="Rate" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }} />
              <Text content="Amount" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }} />
              <Text content="Disc Amt" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }} />
              <Text content="Net Amt" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }} />
              <Text content="Date" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }} />
            </View>
            {data?.investigation_items?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.service_name || '-'} style={{ ...styles.columnText, width: '30%',textAlign:"start" }} />
                <Text content={item.type || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start"}}  />
                <Text content={item.quantity || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"right" }}  />
                <Text content={item.rate || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"right" }}  />
                <Text content={item.amount || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"right" }}  />
                <Text content={item.disc_amt || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"right" }}  />
                <Text content={item.net_amt || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"right" }}  />
                <Text content={formatDate(item.createdAt) || '-'} style={{ ...styles.columnText, width: '10%' }}  />
              </View>
            ))}

            {/* Table for Prescription Items */}
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }} />
              <Text content="Medicine Name" style={{ ...styles.columnText, width: '20%',fontFamily:"Roboto" }} />
              <Text content="Unit" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }}  />
              <Text content="Frequency" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }}  />
              <Text content="Morning" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }} />
              <Text content="Noon" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }}  />
              <Text content="Evening" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }}  />
              <Text content="Night" style={{ ...styles.columnText, width: '10%',fontFamily:"Roboto" }} />
              <Text content="Days" style={{ ...styles.columnText, width: '10%' ,fontFamily:"Roboto"}} />
              <Text content="Date" style={{ ...styles.columnText, width: '10%' ,fontFamily:"Roboto"}} />
            </View>

            {data?.prescription_items?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '10%' }}  />
                <Text content={item.medicine_name || '-'} style={{ ...styles.columnText, width: '20%',textAlign:"start" }} />
                <Text content={item.unit || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }}  />
                <Text content={item.frequency_name|| '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }}  />
                <Text content={item.morning === 'true' ? 'YES' : '' || ''} style={{ ...styles.columnText, width: '10%',textAlign:"start" }}  />
                <Text content={item.noon === 'true' ? 'YES' : '' || ''} style={{ ...styles.columnText, width: '10%',textAlign:"start" }} />
                <Text content={item.evening === 'true' ? 'YES' : '' || ''} style={{ ...styles.columnText, width: '10%',textAlign:"start" }}  />
                <Text content={item.night === 'true' ? 'YES' : '' || ''} style={{ ...styles.columnText, width: '10%',textAlign:"start"}}  />
                <Text content={item.days || '0'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }}  />
                <Text content={formatDate(item.createdAt) || '0'} style={{ ...styles.columnText, width: '10%' }}  />
              </View>
            ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
